'use client';

import type {ReactNode} from 'react';
import {Chip, Link} from '../primitives';

export interface PropertyEyebrowTag {
  label: string;
  icon?: ReactNode;
}

export interface PropertyEyebrowProps {
  primaryLabel: string;
  primaryHref?: string;
  onPrimaryClick?: () => void;
  secondaries?: PropertyEyebrowTag[];
}

export function PropertyEyebrow({primaryLabel, primaryHref, onPrimaryClick, secondaries}: PropertyEyebrowProps) {
  const primary = <Chip>{primaryLabel}</Chip>;
  return (
    <>
      {primaryHref ? (
        <Link href={primaryHref} onClick={onPrimaryClick}>
          {primary}
        </Link>
      ) : (
        primary
      )}
      {secondaries?.map(({label, icon}) => (
        <Chip key={label} type="outline" iconLeft={icon}>
          {label}
        </Chip>
      ))}
    </>
  );
}

PropertyEyebrow.displayName = 'PropertyEyebrow';
